import React from "react";
import { BlockBase } from "../../../blocks/BlockBase/BlockBase";
import Title from "../../../components/texts/title";
import { _sizeHeading } from "../../../core/core";
import "./GroupServices.css";
import { ItemGroupService } from "./ItemGroupService";

interface GroupServicesProps {
  limit?: number;
}

export const GroupServices: React.FC<GroupServicesProps> = ({
  limit,
  ...props
}) => {
  return (
    <BlockBase>
      <Title type={_sizeHeading.h2}>Подборки Для КОМПАНИИ</Title>
      <div className="items-groups">
        <ItemGroupService
          title="Отзывы на карты"
          url="/podborki/otzyvy-na-kartah/"
        />
        <ItemGroupService
          title="Отзывы для кафе"
          image="card_1"
          url="/podborki/otzyvy-dlya-kafe-i-restoranov/"
        />
        <ItemGroupService
          title="Отзывы для СПА"
          image="card_2"
          url="/podborki/otzyvy-dlya-spa/"
        />
      </div>
    </BlockBase>
  );
};
